import React, { useEffect, useMemo, useState } from 'react';
import { Button, Col, Form, Input, notification, Row, Select, Space, Typography, Upload } from 'antd';
import { useMutation, useQuery } from '@tanstack/react-query';
import { AppSelect } from '../../../../constants/appSelect';
import { CloseOutlined, ContainerOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { getTagInfoRequest, updateTagRequest } from '../../../../services/onlinestore/tagServiceRequest';
import UploadButton from '../../../../components/UploadButton';

const { Text, Title } = Typography;

const UpdateTag = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { tagId } = useParams();

  const { data: tagInfo } = useQuery({
    queryKey: ['tagInfo'],
    queryFn: () => getTagInfoRequest({ id: Number(tagId) }),
  });

  useEffect(() => {
    form.setFieldsValue(tagInfo);
  }, [form, tagInfo]);

  // handle submit form
  const { mutate: mutateUpdateTag, isPending: isPendingButtonUpdate } = useMutation({
    mutationFn: updateTagRequest,
    onSuccess: async (data) => {
      if (data?.status === 1) {
        notification.success({
          message: 'Chỉnh sửa tag thành công!',
        });
        navigate(-1);
      } else {
        notification.error({
          message: data?.message || 'Có lỗi xảy ra vui lòng thử lại sau!',
        });
      }
    },
    onError: (error) => {
      notification.error({
        message: error.data?.message || 'Có lỗi xảy ra vui lòng thử lại sau!',
      });
    },
  });

  const handleSubmitForm = (data) => {
    mutateUpdateTag({ ...data, id: tagId });
  };

  return (
    <Form
      name="update-tag"
      form={form}
      layout="vertical"
      className="mb-5"
      onFinish={handleSubmitForm}
    >
      <Row gutter={[16, 0]}>
        <Col xs={24}>
          <Title level={3}>Thêm tag</Title>
        </Col>

        <Col xs={24}>
          <Form.Item
            name="icon"
            label={
              <Text>
                Upload icon<span className="text-red-700">*</span>
              </Text>
            }
            rules={[{ required: true, message: 'Vui lòng tải lên icon' }]}
          >
            <UploadButton name="icon-tag" />
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Form.Item
            name="title"
            label={
              <Text>
                Tên tag <span className="text-red-700">*</span>
              </Text>
            }
            rules={[{ required: true, message: 'Vui lòng nhập tên tag' }]}
          >
            <Input placeholder="Nhập tên tag" />
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Form.Item name="url" label={<Text>Link URL</Text>}>
            <Input placeholder="Nhập đường link" />
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Form.Item
            name="order_place"
            label={
              <Text>
                Thứ tự <span className="text-red-700">*</span>
              </Text>
            }
            rules={[{ required: true, message: 'Vui lòng nhập thứ tự' }]}
          >
            <Input placeholder="Nhập thứ tự..." />
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Form.Item
            name="status"
            label={
              <Text>
                Trạng thái <span className="text-red-700">*</span>
              </Text>
            }
            rules={[{ required: true, message: 'Vui lòng chọn trạng thái' }]}
          >
            <Select
              showSearch
              filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
              placeholder="Chọn trạng thái"
              options={AppSelect.TAG_STATUS}
              allowClear
            />
          </Form.Item>
        </Col>
        <Col xs={24}>
          <Row justify="end">
            <Col>
              <Space>
                <Button htmlType="button" icon={<CloseOutlined />} onClick={() => navigate(-1)}>
                  Hủy bỏ
                </Button>
                <Button loading={isPendingButtonUpdate} htmlType="submit" type="primary" icon={<ContainerOutlined />}>
                  Lưu lại
                </Button>
              </Space>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};

export default UpdateTag;
